import {Yii} from "libraries/interfaces/Yii";

const LOADERS = {
    loadingEmail: Yii.t('wui-sasha-js', 'Chargement en cours'),
    loadingSendEmail: Yii.t('wui-sasha-js', 'Envoi en cours')
};

const CARD_LABELS = {
    header: Yii.t('wui-sasha-js', 'Validation des mails'),
    previousFolder: Yii.t('wui-sasha-js', 'Dossier précédent'),
    nextFolder: Yii.t('wui-sasha-js', 'Dossier suivant'),
    previousView: Yii.t('wui-sasha-js', 'Retour à la saisie'),
    validate: Yii.t('wui-sasha-js', 'Envoyer'),
    currentFolder: Yii.t('wui-sasha-js', 'Dossier')
};

const EMAIL = {
    from: Yii.t('wui-sasha-js', 'De :'),
    replyTo: Yii.t('wui-sasha-js', 'Répondre à :'),
    to: Yii.t('wui-sasha-js', 'À :'),
    subject: Yii.t('wui-sasha-js', 'Objet :'),
    cc: Yii.t('wui-sasha-js', 'Cc :'),
    bcc: Yii.t('wui-sasha-js', 'Bcc :'),
};

export const WORDING = {
    ...CARD_LABELS,
    ...EMAIL,
    ...LOADERS
};